/* eslint-disable react/prop-types */
import React from "react"
import classNames from "classnames"

import {
  largeOnly,
  mediumAndDown,
  mediumAndUp,
  responsive,
  smallOnly,
} from "./styles.module.scss"

const RESPONSIVE_CLASS = {
  smallOnly,
  largeOnly,
  mediumAndUp,
  mediumAndDown,
}

const makeResponsive = (responsiveClassName) => ({
  children,
  className,
  Element = "div",
}) => (
  <Element
    className={classNames(
      responsive,
      RESPONSIVE_CLASS[responsiveClassName],
      className,
    )}
  >
    {children}
  </Element>
)

// components named in a way that completes the sentence "children will show on..."
export const SmallOnly = makeResponsive("smallOnly")
export const LargeOnly = makeResponsive("largeOnly")
export const MediumAndUp = makeResponsive("mediumAndUp")
export const MediumAndDown = makeResponsive("mediumAndDown")
